"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchProviderCampaignGroupsDto = exports.PROVIDER_CAMPAIGN_SYNC_STATUSES = void 0;
const class_validator_1 = require("class-validator");
const cursor_pagination_1 = require("../cursor-pagination");
exports.PROVIDER_CAMPAIGN_SYNC_STATUSES = ["pending", "sync_error"];
class SearchProviderCampaignGroupsDto extends cursor_pagination_1.CursorPaginationOptions {
    provider;
    statuses;
}
exports.SearchProviderCampaignGroupsDto = SearchProviderCampaignGroupsDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsIn)(["ladorian"]),
    __metadata("design:type", String)
], SearchProviderCampaignGroupsDto.prototype, "provider", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsIn)(exports.PROVIDER_CAMPAIGN_SYNC_STATUSES, { each: true }),
    __metadata("design:type", Array)
], SearchProviderCampaignGroupsDto.prototype, "statuses", void 0);
